//~ import {GetLoadables} from './loader'
let exported = [
    'Graph'
];
let loader = ()=>null;
// #if process.env.UIX_CHUNKED === 'true'
loader = ()=>{
    return import(/* webpackChunkName: 'graphology' */ './graphologyLoad');
};
// #endif
// #if process.env.UIX_CHUNKED === 'false'
// //~ import * as L from './graphologyLoad'
// #endif
export const exportedGraphology = {
    names: exported,
    loader
};
